export const VALIDATORS = {
  LessThen: "lessthen",
  GreaterThen: "greaterThen",
  Min: "min",
  Max: "max",
};

const getParsedFieldValue = ({ value, type }) => {
  switch (type) {
    case "number":
      return parseInt(value);
    default:
      return value;
  }
};

export const gatewayFormValidator = (fields = [], dataToValidate = {}) => {
  let errorObject = {};
  fields.forEach((f) => {
    if (f.required && f.display) {
      if (dataToValidate?.[f?.accessor]) {
        let value = dataToValidate?.[f?.accessor];
        if (!Boolean(value)) {
          errorObject[f?.accessor] = `${f?.accessor} is required`;
        } else if (value < 200) {
          errorObject[f?.accessor] = `Minimum deposit amount is 200`;
        }
      } else {
        errorObject[f?.accessor] = `${f?.accessor} is required`;
      }
    }
  });
  return errorObject;
};

/**
 *
 * @param {{customValidations?:Record< string, {validationValue:number;type:keyof typeof VALIDATORS;customMessage:string}>,fields:any[],dataToValidate:object , cstmValidation:any[]}} param0
 * @returns {object}
 */
export const gatewayFormValidatorWithCustomErrors = ({
  fields = [],
  dataToValidate,
  cstmValidation,
}) => {
  let errors = {};
  fields.forEach((field) => {
    if (field?.display === true && field?.required === true) {
      if (
        (!Boolean(dataToValidate?.[field?.accessor]) ||
          dataToValidate?.[field?.accessor] == "") &&
        !Boolean(field?.value)
      ) {
        errors[field?.accessor] = `${field?.accessor} is required`;
      }
    }
    if (cstmValidation?.[field?.accessor]) {
      const cstmValidationError = cstmValidator({
        validationArray: cstmValidation?.[field?.accessor],
        actualValue: getParsedFieldValue({
          value: dataToValidate?.[field?.accessor],
          type: field?.type,
        }),
      });
      if (cstmValidationError) {
        errors[field?.accessor] = cstmValidationError;
      }
    }
  });

  return errors;
};

const cstmValidator = ({ validationArray = [], actualValue }) => {
  let error = null;
  if (validationArray.length === 0) {
    return error;
  }
  for (let i = 0; i < validationArray.length; i++) {
    if (validationArray[i]?.type === VALIDATORS?.Min) {
      if (
        actualValue < validationArray[i]?.validationValue ||
        actualValue === 0
      ) {
        error = validationArray[i]?.customMessage;
        break;
      }
    }

    if (validationArray[i]?.type === VALIDATORS?.Max) {
      if (actualValue > validationArray[i]?.validationValue) {
        error = validationArray[i]?.customMessage;
        break;
      }
    }
  }
  return error;
};
